
import {Vue, Component} from 'vue-property-decorator';
import Pagination from "@/components/Pagination/index.vue";
import {queryCustomerBrands} from "@/api/customer-package";
import {searchCustomer} from "@/api/customer";

@Component({
  name: "customerPackageManagement",
  components: {Pagination}
})
export default class extends Vue {

  private searchParams = {
    customerId: "",
    brandKeyword: "",
    customerOption: [],
  }

  private page = {
    pageNumber: 1,
    pageSize: 20,
    total: 0,
  }

  private tableData = [];

  created() {
    this.getList();
  }

  private async getList() {
    const params = {
      pageNumber: this.page.pageNumber,
      pageSize: this.page.pageSize,
      customerId: this.searchParams.customerId,
      brandKeyword: this.searchParams.brandKeyword,
    }
    const res = await queryCustomerBrands(params) as any;
    this.tableData = res.list;
    this.page.total = Number(res.total);
  }

  private async searchCustomer(name = "") {
    this.searchParams.customerOption = await searchCustomer({ keyword: name }) as any;
  }

  private handleCommand(command) {
    this.gotoBrandPackageList(command.brand, command.row)
  }

  private gotoBrandPackageList(brand, row) {
    const data = { customer: row.customerCode + " " + row.customerAbbr, brandId: brand.id, brand: brand.name }
    const item = encodeURIComponent(JSON.stringify(data));
    this.$router.push(`/customerBrandPackageList?item=${item}`);
  }
}
